import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, InputGroup, FormControl, Col, Row } from 'react-bootstrap'
import UserService from "../../controllers/UserService";
import AuthService from "../../controllers/AuthService";
import { Helmet } from "react-helmet";
import Amplify, { Auth } from 'aws-amplify';
import $, { data } from 'jquery';

Amplify.configure({
    "aws_project_region": "ap-southeast-1",
    "aws_cognito_region": "ap-southeast-1",
    // "aws_user_pools_id": "ap-southeast-1_aSNcGZxJS",
    // "aws_user_pools_web_client_id": "51gmupt86ir7g3eg5t2cgo8tk1",
    "aws_user_pools_id": process.env.REACT_APP_COGNITO_POOL_ID,
    "aws_user_pools_web_client_id": process.env.REACT_APP_COGNITO_CLIENT_ID
});

const Login = props => {
    const [cognitoUser, setCognitoUser] = useState(undefined);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newConfirmPassword, setNewConfirmPassword] = useState("");
    const [systemAvaliable, setSystemAvaliable] = useState(true);
    const history = useHistory();


    useEffect(() => {

        if (localStorage.getItem("user")) {
            history.push("/");
        }
        props.onChange({ 'backgroundColor': 'bg-white' })
        $('.error').hide();
        $('.create-password').hide();
        checkAPIConnected()
    }, [])

    const onChangeUsername = (e) => {
        const username = e.target.value;
        setUsername(username);
    };

    const onChangePassword = (e) => {
        const password = e.target.value;
        setPassword(password);
    };

    const onChangeNewPassword = (e) => {
        const newPassword = e.target.value;
        setNewPassword(newPassword);
    };

    const onChangeNewConfirmPassword = (e) => {
        const newConfirmPassword = e.target.value;
        setNewConfirmPassword(newConfirmPassword);
    };

    const checkAPIConnected = () => {
        UserService.distinctYearTerm().then((response) => {
            // Status OK
            $('.system-unavaliable').hide();
            setSystemAvaliable(true)
        }).catch(e => {
            // Status Unavaliable

            $('.system-unavaliable').show();
            setSystemAvaliable(false)
        });
    }

    const handleLogin = (e) => {
        $('.error').hide();
        if (!systemAvaliable) {
            $('.system-unavaliable').show();
            return;
        }

  
        Auth.signIn(username.trim(), password.trim())
            .then(cognitoUser => {
                if (cognitoUser.challengeName === 'NEW_PASSWORD_REQUIRED') {
                    setNewPasswordRequire(true);
                    setCognitoUser(cognitoUser);
                } else {
                    // Login Successful
                    console.log('cognitoUser', cognitoUser)
                    UserService.getCognitorUserProfile(username.trim()).then((response) => {

                        let currentData = ['ACTIVE', []];
                        if (response.data && response.data.data.status !== 'ACTIVE') {
                            currentData[0] = '';
                            $('.inactive-user').show();
                            $('.incorrect-pass').hide();

                        } else if (response.data && response.data.data) {
                            currentData[1] = response.data.data;
                            localStorage.setItem("user", JSON.stringify(response.data.data));
                            if (response.data.data && response.data.data.room && response.data.data.room.id) {
                                localStorage.setItem("roomId", response.data.data.room.id);
                            }
                            if (response.data.data && response.data.data.domain) {
                                let features = response.data.data.domain.features
                                if (response.data.data.domain.features === null || response.data.data.domain.features === [] || response.data.data.domain.features === '') {
                                    features = ['homeroom', 'friendship', 'pocket-book', 'riasec']
                                }
                                localStorage.setItem("features", features);
                            }
                            localStorage.setItem("access_token", cognitoUser.signInUserSession.accessToken.jwtToken);
                            AuthService.setLoginDate();

                            // redirect
                            // if (response.data.data.roles[0].toLowerCase() === 'student') {
                            //   window.location.href = '/activity'
                            // } else if (response.data.data.roles[0].toLowerCase() === 'headmaster') {
                            //     window.location.href = '/report'
                            // } else if (response.data.data.roles[0].toLowerCase() === 'teacher') {
                            //     UserService.getActivities({
                            //         'status': 'RUNNING',
                            //         'domain': AuthService.getCurrentUser() && AuthService.getCurrentUser().domain && AuthService.getCurrentUser().domain.name ? AuthService.getCurrentUser().domain.name : '',
                            //         'roomId': AuthService.getCurrentUser() && AuthService.getCurrentUser().room && AuthService.getCurrentUser().room.id ? AuthService.getCurrentUser().room.id : '', 
                            //     }).then((response) => {
                            //         console.log(response.data.data)
                            //         console.log(response.data.data.length)
                            //         if (response && response.data && response.data.data.length > 0 && AuthService.getUserRole() === 'teacher') {
                            //             console.log(`/activity/live/${response.data.data[0].id}`)
                            //             window.location.href = `/activity/live/${response.data.data[0].id}`
                            //         } else {
                            //             window.location.href = '/activity'
                            //         }
                            //     });
                            // }
                            return currentData;
                        }
                    }).then((currentData) => {

                        UserService.getDomain(currentData[1].domain.id).then((response2) => {

                            if (response2.data && response2.data.data.logoUrl) {
                                localStorage.setItem("logoUrl", response2.data.data.logoUrl);
                            }
                            return currentData
                        }).then((currentData) => {
                            if (currentData[0] === 'ACTIVE' && currentData[1] !== []) {
                                // redirect
                                if (currentData[1].roles[0].toLowerCase() === 'student') {
                                    window.location.href = '/activity'
                                } else if (currentData[1].roles[0].toLowerCase() === 'headmaster') {
                                    window.location.href = '/report'
                                } else if (currentData[1].roles[0].toLowerCase() === 'teacher') {
                                    UserService.getActivities({
                                        'status': 'RUNNING',
                                        'domain': AuthService.getCurrentUser() && AuthService.getCurrentUser().domain && AuthService.getCurrentUser().domain.name ? AuthService.getCurrentUser().domain.name : '',
                                        'roomId': AuthService.getCurrentUser() && AuthService.getCurrentUser().room && AuthService.getCurrentUser().room.id ? AuthService.getCurrentUser().room.id : '',
                                    }).then((response) => {
                                        console.log(response.data.data)
                                        console.log(response.data.data.length)
                                        if (response && response.data && response.data.data.length > 0 && AuthService.getUserRole() === 'teacher') {
                                            console.log(`/activity/live/${response.data.data[0].id}`)
                                            window.location.href = `/activity/live/${response.data.data[0].id}`
                                        } else {
                                            window.location.href = '/activity'
                                        }
                                    });
                                }
                            }

                        });

                    })
                }
            }).catch(e => {
                // incorrect password
                console.log(e)
                $('.inactive-user').hide();
                $('.incorrect-pass').show();
            });
    };

    const handleCreatePassword = (e) => {
        $('.error').hide();
        var status = true;

        if (!newPassword || !newConfirmPassword) {
            $('.missing-data').show();
            status = false;
        } else if (newPassword !== newConfirmPassword) {
            $('.notmatch-data').show();
            status = false;
        } else if (newPassword.length < 6) {
            $('.min-6').show();
            status = false;
        }


        if (status) {
            Auth.completeNewPassword(cognitoUser, newConfirmPassword)
                .then((data) => {
                    // Success 
                    console.log(data)
                    window.location.href = '/password-created';
                }).catch(e => {
                    // case password length < 6
                    console.log(e)
                });
        }

    };

    const setNewPasswordRequire = (bool) => {
        $('.create-password').show();
        $('.login-user').hide();
    }

    return (
        <div>
            <Helmet>
                <title>เข้าสู่พื้นที่ของการปรับใจ จิตวิทยาเชิงบวกเริ่มต้นได้ที่นี่ - Mindsetmaker.co</title>
                <meta property="og:title" content="เข้าสู่พื้นที่ของการปรับใจ จิตวิทยาเชิงบวกเริ่มต้นได้ที่นี่ - Mindsetmaker.co" />
                <meta property="og:description" content="เข้าสู่ระบบกิจกรรมปรับใจสำหรับชั่วโมงโฮมรูม จิตวิทยาเชิงบวกเริ่มต้นได้ในห้องเรียน โดยนำ 24 อุปนิสัยเชิงบวกมาใช้ผ่านเรื่องราวแรงบันดาลใจทั่วโลก" />
            </Helmet>
            <Row>
                <Col className="text-center w-100 full-height login-user">
                    <div className="login-page mx-3" align="center">
                        <h1 className="pt-4 pt-md-5 header primary-text">ต้อนรับทุกคนเข้าสู่พื้นที่<span className="doNotWrap">ของการปรับใจ</span></h1>
                        <h5 className="font-weight-normal font-sarabun line-height-26">ใส่รหัสตามที่ได้รับ ในช่องข้างล่างได้เลยค่ะ</h5>
                        <h6 className="gray-text font-sarabun pb-3">* หากสนใจนำ Strength School ไปใช้ในโรงเรียน <span className="doNotWrap"><a href="https://www.mindsetmaker.co/products/strength-school" className="green-text">คลิกที่นี่</a> ได้เลย</span></h6>
                        <form className="login-form">
                            <InputGroup className="mb-3 mt-lg-1 border-blue border-radius-10">
                                <InputGroup.Prepend>
                                    <InputGroup.Text id="basic-addon1"><img src="/images/icons/login/username.png" width="23" /></InputGroup.Text>
                                </InputGroup.Prepend>
                                <FormControl
                                    placeholder="USERNAME"
                                    value={username}
                                    onChange={onChangeUsername}
                                    aria-label="Username"
                                    aria-describedby="basic-addon1"
                                />
                            </InputGroup>
                            <InputGroup className="mb-3 border-blue mt-lg-2 border-radius-10">
                                <InputGroup.Prepend>
                                    <InputGroup.Text id="basic-addon1"><img src="/images/icons/login/password.png" width="23" /></InputGroup.Text>
                                </InputGroup.Prepend>
                                <FormControl
                                    placeholder="PASSWORD"
                                    value={password}
                                    type="password"
                                    onChange={onChangePassword}
                                    aria-label="Password"
                                    aria-describedby="basic-addon1"
                                />
                            </InputGroup>
                            <h5 className="error incorrect-pass red-text font-sarabun text-left">ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง</h5>
                            <h5 className="error system-unavaliable red-text font-sarabun text-left">ขออภัยในความไม่สะดวก ระบบกำลังปิดปรับปรุงเพื่อเพิ่มประสิทธิภาพการให้บริการ</h5>
                            <h5 className="error inactive-user red-text font-sarabun text-left">Account ไม่พร้อมใช้งานกรุณาติดต่อผู้ดูแลระบบ</h5>
                            <div>
                                <Button variant="primary" className="signin w-100  mt-lg-2" onClick={handleLogin}>เข้าสู่ระบบ</Button>
                            </div>
                            <div className="pt-2" align="center">เวลาเปิดใช้งานระบบ Strength School<br />
 	                                วันจันทร์ - ศุกร์ เวลา 6:00-20:00 น.</div>
                            <div className="pt-2" align="right">
                                {/* <p><a href="/" className="green-text font-sarabun">ลืมรหัสผ่าน</a></p> */}
                            </div>
                        </form>
                    </div>
                </Col>
                <Col className="text-center w-100 full-height create-password">
                    <div className="login-page mx-3" align="center">
                        <h1 className="pt-4 pt-md-5 header primary-text">สร้างรหัสผ่าน</h1>
                        <h5 className="font-weight-normal font-sarabun line-height-26">ในการใช้งานครั้งแรกคุณจำเป็นต้องสร้างรหัสผ่านเพื่อใช้งานในครั้งถัดไป</h5>
                        <form className="login-form">
                            <InputGroup className="mb-3 mt-lg-1 border-blue border-radius-10">
                                <InputGroup.Prepend>
                                    <InputGroup.Text id="basic-addon1"><img src="/images/icons/login/username.png" width="23" /></InputGroup.Text>
                                </InputGroup.Prepend>
                                <FormControl
                                    id="newPassword"
                                    placeholder="สร้างรหัสผ่าน"
                                    type="password"
                                    name="newPassword"
                                    value={newPassword}
                                    onChange={onChangeNewPassword}
                                    aria-label="password"
                                    aria-describedby="basic-addon1"
                                />
                            </InputGroup>
                            <h5 className="gray-text font-sarabun pb-3 text-left">*อย่างน้อย 6 อักขระ</h5>

                            <InputGroup className="mb-3 border-blue mt-lg-2 border-radius-10">
                                <InputGroup.Prepend>
                                    <InputGroup.Text id="basic-addon1"><img src="/images/icons/login/password.png" width="23" /></InputGroup.Text>
                                </InputGroup.Prepend>
                                <FormControl
                                    id="newConfirmPassword"
                                    placeholder="ยืนยัน"
                                    value={newConfirmPassword}
                                    type="password"
                                    name="newConfirmPassword"
                                    onChange={onChangeNewConfirmPassword}
                                    aria-label="confirmpassword"
                                    aria-describedby="basic-addon1"
                                />
                            </InputGroup>
                            <h5 className="error missing-data red-text font-sarabun text-left">กรุณากรอกข้อมูลให้ครบถ้วน</h5>
                            <h5 className="error notmatch-data red-text font-sarabun text-left">รหัสผ่านของคุณทั้ง 2 ช่องไม่ตรงกัน กรุณาตรวจสอบอีกครั้งค่ะ</h5>
                            <h5 className="error min-6 red-text font-sarabun text-left">รหัสผ่านของคุณมีน้อยกว่า 6 อักขระ</h5>

                            <div>
                                <Button variant="primary" className="signin w-100  mt-lg-2" onClick={handleCreatePassword}>ยืนยัน</Button>
                            </div>
                        </form>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default Login;